import InfoBox from './InfoBox'
import './InfoBox.sass'

export default InfoBox
